import { ShopperHomePage } from "./../shopper-home/shopper-home";
import { ViewHeaderPage } from "./../view-header/view-header";
import { ShopperMissionOutstandingPage } from "./../shopper-mission-outstanding/shopper-mission-outstanding";
import { ShopperMissionSocialPage } from "./../shopper-mission-social/shopper-mission-social";
import { ShopperMissionShoppingPage } from "./../shopper-mission-shopping/shopper-mission-shopping";
import { Component } from "@angular/core";
import { IonicPage, NavController, NavParams } from "ionic-angular";
import { Storage } from "@ionic/storage";

@IonicPage()
@Component({
  selector: "page-shopper-mission",
  templateUrl: "shopper-mission.html",
})
export class ShopperMissionPage {
  theme = 1;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private storage: Storage
  ) {}

  async ionViewDidLoad() {
    this.theme = await this.storage.get("theme");
    // console.log('ionViewDidLoad ShopperMissionPage');
  }

  social() {
    this.navCtrl.push(ShopperMissionSocialPage);
  }

  shipping() {
    this.navCtrl.push(ShopperMissionShoppingPage);
  }

  outstanding() {
    this.navCtrl.push(ShopperMissionOutstandingPage);
  }

  backPage() {
    this.navCtrl.setRoot(ShopperHomePage);
  }

  openHeadPage() {
    this.navCtrl.push(ViewHeaderPage);
  }

  homePage() {
    this.navCtrl.setRoot(ShopperHomePage);
  }
}



// WEBPACK FOOTER //
// ./src/pages/shopper-mission/shopper-mission.ts